import axios from "axios";
import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { useSettings } from '../SettingsContext';
import { toast } from "react-toastify";
import BreadCumb from "../component/BreadCumb";
import CompanyContactSection from "../component/CompanyContactSection";
import {Helmet} from "react-helmet-async";

const Contact = () => {
    const setting = useSettings();
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        subject: '',
        message: '',
        honeypot: '',
        timestamp: Date.now()
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formData.honeypot) {
            toast.error('Please send message later.');
            return;
        }
        const submissionTime = Date.now();
        const timeDiff = submissionTime - formData.timestamp;

        if (timeDiff < 3000) {
            toast.error('Please send message later.');
            return;
        }
        try {
            const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
            const Url = process.env.REACT_APP_API_CONTACT_MESSAGE_STORE;
            const response = await axios.post(`${apiBaseUrl}${Url}`, formData);

            if (response.status === 200) {
                toast.success('Message sent successfully!');
                setFormData({ name: '', phone: '', subject: '', message: '', honeypot: '', timestamp: Date.now() });
            } else {
                toast.error('Something went wrong. Try again.');
            }
        } catch (error) {
            toast.error('Failed to send message.');
        }
    };

    return (
        <>
            <Helmet>
                <title>Tarif Overseas Ltd. | Connect With Our Experts</title>
                <meta name="description" content="Tarif Overseas Ltd. is a trusted overseas recruitment agency in Bangladesh providing professional manpower recruitment services."/>
                <link rel="canonical" href={`https://tarifoverseasltd.com/contact-us`}/>
            </Helmet>
            <main className="main" style={{ backgroundColor: '#f8fafc' }}>
            <BreadCumb image={"contact_us.jpg"} />
            <CompanyContactSection setting={setting} />

            {/* Contact Info Cards Area */}
            <div className="contact-area pb-60 pt-50">
                <div className="container">
                    <div className="row g-4 justify-content-center">
                        {/* Address */}
                        <div className="col-12 col-md-6 col-xl-3">
                            <div className="card border-0 p-4 shadow-sm rounded-4 text-center h-100 bg-white" style={{ transition: '0.3s' }}>
                                <div className="mb-3 text-primary fs-3">
                                    <i className="fa fa-map-marker-alt"></i>
                                </div>
                                <h5 className="fw-bold text-dark mb-2">Office Address</h5>
                                <p className="text-muted small mb-0">{setting?.address || "Dhaka, Bangladesh"}</p>
                            </div>
                        </div>

                        {/* Phone */}
                        <div className="col-12 col-md-6 col-xl-3">
                            <div className="card border-0 p-4 shadow-sm rounded-4 text-center h-100 bg-white" style={{ transition: '0.3s' }}>
                                <div className="mb-3 text-primary fs-3">
                                    <i className="fa fa-phone-alt"></i>
                                </div>
                                <h5 className="fw-bold text-dark mb-2">Call Us</h5>
                                <p className="text-muted small mb-0">
                                    <a href={`tel:${setting?.footer_phone}`} className="text-decoration-none text-muted">
                                        {setting?.footer_phone || '+8801798 733185'}
                                    </a>
                                </p>
                            </div>
                        </div>

                        {/* Email */}
                        <div className="col-12 col-md-6 col-xl-3">
                            <div className="card border-0 p-4 shadow-sm rounded-4 text-center h-100 bg-white" style={{ transition: '0.3s' }}>
                                <div className="mb-3 text-primary fs-3">
                                    <i className="fa fa-envelope"></i>
                                </div>
                                <h5 className="fw-bold text-dark mb-2">Email Us</h5>
                                <p className="text-muted small mb-0">
                                    <a className="text-decoration-none text-muted" href={`mailto:${setting?.email}`}>
                                        {setting?.email || 'ceo.tarifoverseas@gmail.com'}
                                    </a>
                                </p>
                            </div>
                        </div>

                        {/* Open Time */}
                        <div className="col-12 col-md-6 col-xl-3">
                            <div className="card border-0 p-4 shadow-sm rounded-4 text-center h-100 bg-white" style={{ transition: '0.3s' }}>
                                <div className="mb-3 text-primary fs-3">
                                    <i className="fa fa-clock"></i>
                                </div>
                                <h5 className="fw-bold text-dark mb-2">Open Time</h5>
                                <p className="text-muted small mb-0">{setting?.office_hour || 'Sat - Thu: 9:00 - 18:00'}</p>
                            </div>
                        </div>
                    </div>

                    {/* Contact Form & Image Section */}
                    <div className="contact-form-wrap pt-80">
                        <div className="row g-5 align-items-center">
                            <div className="col-lg-7">
                                <div className="card border-0 p-4 p-md-5 shadow-sm rounded-4 bg-white">
                                    <div className="contact-form-header mb-4">
                                        <h3 className="fw-bold text-dark">Do you have any questions?</h3>
                                        <p className="text-muted small">Fill out the form below and our team will get back to you shortly.</p>
                                    </div>
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <div className="form-group">
                                                    <input
                                                        type="text"
                                                        className="form-control rounded-pill px-4 py-3 bg-light border-0"
                                                        name="name"
                                                        placeholder="Your Name"
                                                        value={formData.name}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <div className="form-group">
                                                    <input
                                                        type="text"
                                                        className="form-control rounded-pill px-4 py-3 bg-light border-0"
                                                        name="phone"
                                                        placeholder="Your Phone Number"
                                                        value={formData.phone}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group mb-3">
                                            <input
                                                type="text"
                                                className="form-control rounded-pill px-4 py-3 bg-light border-0"
                                                name="subject"
                                                placeholder="Subject"
                                                value={formData.subject}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        <div className="form-group mb-4">
                                            <textarea
                                                name="message"
                                                className="form-control rounded-4 p-4 bg-light border-0"
                                                rows="5"
                                                placeholder="Write your message here..."
                                                value={formData.message}
                                                onChange={handleChange}
                                                required
                                            ></textarea>
                                        </div>

                                        {/* Honeypot field - hidden from the user */}
                                        <input
                                            type="hidden"
                                            name="honeypot"
                                            value={formData.honeypot}
                                            onChange={handleChange}
                                        />

                                        <button type="submit" className="btn btn-primary w-100 py-3 rounded-pill fw-bold shadow-sm">
                                            Send Message <i className="fa fa-paper-plane ms-2"></i>
                                        </button>
                                    </form>
                                </div>
                            </div>
                            <div className="col-lg-5 text-center">
                                <div className="contact-img overflow-hidden rounded-4 shadow-sm bg-white p-3 border">
                                    <img
                                        src="assets/customer-service-representative.jpg"
                                        alt="Customer Support"
                                        className="img-fluid rounded-3 w-100"
                                        style={{ maxHeight: '420px', objectFit: 'cover' }}
                                        onError={(e) => {
                                            e.target.src = "https://i.ibb.co/3W83s0m/globe-logo-placeholder.png";
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Map Section */}
            {setting?.map && (
                <div className="container pb-80">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="card border-0 p-2 shadow-sm rounded-4 bg-white overflow-hidden">
                                <iframe
                                    src={setting.map}
                                    width="100%"
                                    height="450"
                                    className="rounded-3 border-0"
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    title="Google Map Location"
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            )}


        </main>
        </>
    );
}

export default Contact;